import { isProdLike } from "@imi/utils/env.ts";
import { configureStore } from "@reduxjs/toolkit";
import { batchSelectionSlice } from "@src/routes/projects/$projectId/selections/batch/$category/store/batchSelectionSlice";
import { directSelectionSlice } from "@src/routes/projects/$projectId/selections/direct/store/directSelectionSlice";
import { technicalSelectionSlice } from "@src/routes/projects/$projectId/selections/technical/$category/store/technicalSelectionSlice";
import { useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  devTools: !isProdLike(import.meta.env.VITE_ENVIRONMENT),
  reducer: {
    batchSelection: batchSelectionSlice.reducer,
    directSelection: directSelectionSlice.reducer,
    technicalSelection: technicalSelectionSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
